/**
 * QUÉ FAVORITAS SALEN EN CADA COMIDA. Una regla, para la ventana de favoritas
 * (`FavoritasDeComida`), la tarjeta de la comida vacía (`MealCard`) y Nutrición. Vivía en la
 * ventana y el PR 5 (16-10) la copió en la tarjeta del post vacío sin la favorita fija: el
 * cliente con «Tu postentreno de siempre» y ninguna favorita del post no llegaba a ella.
 *
 * UNA FAVORITA NO VALE PARA CUALQUIER COMIDA (Francisco, 25-08). El intra y el post son otra
 * cosa: un desayuno no se puede poner de post, y un post -whey con crema de arroz, sin grasa-
 * no es una comida normal. Así que en el peri solo salen las de ESE peri, y en una comida
 * normal solo las de comidas normales.
 *
 * Y EN EL POST, SU POSTENTRENO DE SIEMPRE DELANTE (Jesús, 27-09: «te tiene que meter en sus
 * postentrenos favoritos, no en las comidas favoritas»).
 */
const esPeri = (k) => ['Intra', 'Post'].includes(k);

export const valeAqui = (fav, mealKey) => {
    const origen = fav?.comida_origen;
    if (!origen) return !esPeri(mealKey);   // las viejas, sin origen, son de comida normal
    return esPeri(mealKey) ? origen === mealKey : !esPeri(origen);
};

/** Las favoritas fijas de esa comida: en el post, su postentreno de siempre (`peri_favorito`). */
export const fijasDeLaComida = (mealKey, periFavorito) =>
    mealKey === 'Post' && (periFavorito?.post?.alimentos || []).length
        ? [{ id: 'peri-favorito-post', name: 'Tu postentreno de siempre', fija: true,
             comida_origen: 'Post', alimentos: periFavorito.post.alimentos }]
        : [];

/** Lo que se le ofrece en esa comida: las fijas delante y luego las suyas que valen ahí. */
export const favoritasDeLaComida = (todas, mealKey, periFavorito) =>
    [...fijasDeLaComida(mealKey, periFavorito), ...(todas || []).filter((f) => valeAqui(f, mealKey))];
